import { IconComponent } from './types';

const PictureIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2519_69)">
      <path
        d="M5.94277 8.5L7.24321 6.82428L8.5 8.5H5.94277ZM4.26279 7.54796L5.05352 8.5H3.52232L4.26279 7.54796ZM11 9.5V2.5C11 1.67386 10.3261 1 9.5 1H2.5C1.67386 1 1 1.67386 1 2.5V9.5C1 10.3261 1.67386 11 2.5 11H9.5C10.3261 11 11 10.3261 11 9.5Z"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2519_69">
        <rect width="12" height="12" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default PictureIcon;
